<template>
    <div></div>
</template>
  <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {},
    mounted() {},
    created() {},
};
</script>
